//@ts-nocheck
import { useCallback, useState } from 'react';
import useModelInventory from './useModelInventory';

export default function useModelCompletedCycle() {
  const { getHistory } = useModelInventory();
  const [completedLifeCycle, setcompletedLifeCycle] = useState([]);

  const getModelCompletedCycle = useCallback(
    async (body) => {
      const res = await getHistory(body, false);
      const ModelStatus = [];

      if (res?.data) {
        const ModelHistory = [...(res?.data?.history || [])];

        if (ModelHistory.length === 1) {
          ModelStatus.push(ModelHistory[0]?.previous_value);
          ModelStatus.push(ModelHistory[0]?.current_value);
        }

        if (ModelHistory.length > 1) {
          ModelHistory.reverse().forEach((_history, index) => {
            if (ModelHistory.length - 1 === index) {
              ModelStatus.push(_history?.previous_value);
              ModelStatus.push(_history?.current_value);
            } else {
              ModelStatus.push(_history?.previous_value);
            }
          });
        }
      }

      setcompletedLifeCycle(ModelStatus);
      return ModelStatus;
    },
    [getHistory, setcompletedLifeCycle]
  );
  return {
    completedLifeCycle,
    getModelCompletedCycle,
  };
}
